class CustomCategoryControl {
  _options: {
    categories: [],
    mapData : []
  };

  constructor(options) {
    this._options = Object.assign({}, this._options, options)
  }

  addHeading() {
    var heading = document.createElement('h3');
    heading.appendChild(document.createTextNode('Filter'));
    return heading;
  }

  onAdd(map){
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl wp-mapbox-gl-js-custom-category-control';
    this.container.appendChild(this.addHeading());

    var thisCategoryDiv = this._addCategories(this._options.categories);
    this.container.appendChild(thisCategoryDiv);
    return this.container;
  }
  onRemove(){
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
  _addCategories(categories) {
    const el = window.document.createElement('div')
    categories.forEach(function(category) {
      const innerElement = window.document.createElement('div')
      const input = window.document.createElement('input')
      input.type = "checkbox";
      input.checked = "checked";
      input.name = category;
      input.value = category;
      input.id = 'wp-mapbox-gl-js-'+category;
      input.addEventListener('change',(e)=>{
        if(e.target.checked) {
          this._options.mapData.forEach(function(feature) {
            if(feature.properties.category===e.target.value) {
              this.map.setLayoutProperty(feature.id,'visibility','visible');
            }
          }.bind(this));
        } else {
          this._options.mapData.forEach(function(feature) {
            if(feature.properties.category===e.target.value) {
              this.map.setLayoutProperty(feature.id,'visibility','none');
            }
          }.bind(this));
        }
      });
      innerElement.appendChild(input)

      var label = document.createElement('label')
      label.htmlFor = 'wp-mapbox-gl-js-'+category;;
      label.appendChild(document.createTextNode(category));
      innerElement.appendChild(label)

      el.appendChild(innerElement);
    }.bind(this));
    return el;
  }

  updateCategories(categories) {
    this.container.innerHTML = '';
    this.container.appendChild(this.addHeading());
    var thisCategoryDiv = this._addCategories(categories);
    this.container.appendChild(thisCategoryDiv);
  }

  updateMapData(mapData) {
    this._options.mapData = mapData;
  }

}

export default CustomCategoryControl;



// WEBPACK FOOTER //
// ./src/components/controls/CustomCategoryControl.js